import React from 'react';
import Infinite from 'react-list';
import './styles.css';
import get from 'lodash/get';
import CollegeEventRow from './CollegeEventRow';
import Grid from '../../../components/Grid';
import { studentProfile, parseGraphQL } from './eventsHelper';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import {
  getSingleClickEvent,
  getBatchClickEvent,
} from '../../../utils/clickTrackingManager';

class CollegeEvents extends React.Component {
  static propTypes = {
    userData: PropTypes.object,
    scid: PropTypes.number,
    clickTrackingEvents: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      events: [],
    };
  }

  componentDidMount() {
    const { scid, userData } = this.props;

    if (!this.props.fetchCollegeEvents) return;

    this.props
      .fetchCollegeEvents({
        scid: scid,
        studentProfile: studentProfile(userData),
        pagination: { first: 10000 },
      })
      .then((eventsData) => {
        this.setState({ events: parseGraphQL(eventsData.events) }, this.handleEventsShown);
      });
  }

  handleClickTracking = (clickEvent) => {
    if (this.hasCoppaFerpaBlock()) return;
    this.props.clickTrackingEvents(getSingleClickEvent(clickEvent, this.props.userData));
  };

  handleEventsShown = () => {
    if (this.hasCoppaFerpaBlock()) return;
    if (!this.state.events.length) return;
    this.props.clickTrackingEvents(
      getBatchClickEvent(this.state.events, this.props.userData),
    );
  };

  hasCoppaFerpaBlock = () => get(this.props, 'userData.coppa', false);
  hasFerpaBlock = () => get(this.props, 'userData.hasFerpaBlock', false);

  renderEvent = (index, key) => {
    const { events } = this.state;
    const { userData } = this.props;

    const event = events[index];

    return (
      <Grid.Row key={key} className="event-row" data-cy="event-row">
        <CollegeEventRow
          event={event}
          handleClickTracking={this.handleClickTracking}
          userData={userData}
          hasCoppaFerpaBlock={this.hasCoppaFerpaBlock()}
          hasFerpaBlock={this.hasFerpaBlock()}
        />
      </Grid.Row>
    );
  };

  render() {
    const { events } = this.state;
    const { collegeData } = this.props;

    const schoolName = get(collegeData, 'fullProfile.overview.schoolName.value', '');

    return (
      <>
        {events.length > 0 ? (
          <div className="college-events-container" name="events">
            <h2 className="upcoming-events-header">
              Upcoming events hosted by {schoolName}
            </h2>
            <div className="events-list">
              <Infinite
                length={events.length}
                minSize={5}
                pageSize={5}
                itemRenderer={this.renderEvent}
                useTranslate3d
              />
            </div>
          </div>
        ) : null}
      </>
    );
  }
}

export default injectIntl(CollegeEvents);
